import React, { Component } from 'react'
import { observer } from 'mobx-react'
import styles from './title.css'

@observer(['practiceStore'])

export default class Title extends Component{
  render (){
    const { questionIds,  id} = this.props;
    let show = 1;
    for(let i = 0;i<questionIds.length;i++) {
      if(questionIds[i] === id) {
        show = i+1;
        break;
      }
    }
   return (
     <div className={ styles.root }>
       <div className={styles.title}>
         <div className={ styles.indicator }>{`Question ${show} of ${questionIds.length}`}</div>
         {questionIds.length > 30 && <div className={styles.notice}>做题进度已经保存，下次可以继续练习</div>}
       </div>
       <div className={ styles.intro }>
         {
           this.props.introduction.text.map((item,index)=> {
             return (
               <div key={index} dangerouslySetInnerHTML={{ __html: item.raw }}></div>
             )
           })
         }
       </div>
     </div>
   )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Practice/Main/Title.js
 **/